export default __webpack_public_path__ + "static/media/element_44.6c0e9415.avif";